import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsFinancialsHub() {
  return <SectionHub sectionPath="03-fundamentals/financials" />;
}
